import RestApiModel from '@/services/Api/RestApiModel';

class Applications extends RestApiModel {
  static getResourceEndpoint() {
    return '/apps';
  }
}

export default Applications;
